import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import schemas from 'modules/custom_resources/store/collections/customResources/schemas'
import Schema from 'modules/custom_resources/store/models/customResources/Schema'

interface Props {
  back: { href: string }
  schemaId: number
}

const CustomTableDestroyPage = ({ back, schemaId }: Props) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const schema = schemas.get(schemaId)

  useAsyncData(
    () =>
      schemas.fetch({
        data: {
          topic_names: [Schema.TOPIC_NAMES.employees, Schema.TOPIC_NAMES.performance],
        },
      }),
    []
  )

  const { running, performAction } = useAsyncAction(async () => {
    await schema?.destroy()
    navigate(navigation.settings.customizations.fullPath())
  })

  const onClose = () => navigate(back.href)

  return (
    <Modal
      illustration="delete"
      title={i18n.t('settings.custom_resources.delete_modal.title')}
      description={i18n.t('settings.custom_resources.delete_modal.description')}
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <Button type="negative" disabled={running} submit>
          {i18n.t('settings.custom_resources.delete_modal.button')}
        </Button>
      }
    />
  )
}

export default observer(CustomTableDestroyPage)
